
import { Component, Input } from "@angular/core";
import Chart from "chart.js/auto";
import { SectionHeaderComponent } from "../../../../../shared/section-header/section-header.component";
import { PublicFlowDTO } from "@models/public-flow";

@Component({
    selector: "app-public-flow-chart",
    imports: [SectionHeaderComponent],
    templateUrl: "./public-flow-chart.component.html",
    styleUrl: "./public-flow-chart.component.scss"
})
export class PublicFlowChartComponent {
  private _data: PublicFlowDTO | null = null;
  @Input({ required: true }) set data(data: PublicFlowDTO | null) {
    this._data = data;
    this.updateChart();
  }
  get data() {
    return this._data;
  }
  chart?: Chart;

  updateChart() {
    if (this.data)
      this.chart = new Chart("canvas", {
        type: "line",
        data: {
          labels: this.data.validated_flow.map((dataEntry) => dataEntry.time),
          datasets: [
            {
              label: "Fluxo de pessoas",
              data: this.data.validated_flow.map(
                (dataEntry) => dataEntry.quantity,
              ),
              borderWidth: 2,
              borderColor: "#7c0084",
              backgroundColor: "#ffe600",
              pointRadius: 6,
              pointHoverRadius: 8,
              pointHoverBorderWidth: 2,
            },
          ],
        },
        options: {
          plugins: {
            legend: {
              position: "bottom",
            },
          },
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });
  }
}
